module.exports = __webpack_public_path__ + "img/safe.37826902.svg";